import { render, staticRenderFns } from "./ImportMaterialModal.vue?vue&type=template&id=61dfec90&scoped=true"
import script from "./ImportMaterialModal.vue?vue&type=script&lang=js"
export * from "./ImportMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dfec90",
  null
  
)

export default component.exports